import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { webColors } from '../../../../constants/webStyles';
import { useIsMobile } from '../../../../hooks/useIsMobile';

const FEATURES = [
  'Thousands of candidates on Supermedic',
  'Locum, contract, permanent and International hiring',
  'One platform for your entire healthcare workforce needs.',
];

const BrandingPanel = () => {
  const isMobile = useIsMobile();
  if (isMobile) return null;
  return (
    <View style={styles.brandSide}>
      <View style={styles.brandContent}>
        <Text style={styles.brandIcon}>🏥</Text>
        <Text style={styles.brandTitle}>
          For Healthcare Employers: Your Complete Hiring Solution
        </Text>
        <Text style={styles.brandSubtitle}>
          From urgent locum coverage to permanent hires — Doctors, Nurses, pharmacists, dentists to admin, pharma, support staff and non-clinical professionals ready to work.
        </Text>

        <View style={styles.brandFeatures}>
          {FEATURES.map((feature, index) => (
            <View key={index} style={styles.brandFeature}>
              <View style={styles.brandFeatureIcon}>
                <Text style={styles.featureCheck}>✓</Text>
              </View>
              <Text style={styles.featureText}>{feature}</Text>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  brandSide: {
    flex: 1,
    background: 'linear-gradient(135deg, #1e3a5f 0%, #2557a7 50%, #3b82f6 100%)',
    backgroundColor: webColors.secondary,
    padding: 60,
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  brandContent: {
    maxWidth: 500,
    zIndex: 1,
  },
  brandIcon: {
    fontSize: 64,
    marginBottom: 24,
  },
  brandTitle: {
    fontSize: 36,
    fontWeight: '700',
    color: '#ffffff',
    marginBottom: 16,
    lineHeight: 44,
  },
  brandSubtitle: {
    fontSize: 18,
    color: 'rgba(255, 255, 255, 0.9)',
    lineHeight: 28,
    marginBottom: 40,
  },
  brandFeatures: {
    gap: 16,
  },
  brandFeature: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  brandFeatureIcon: {
    width: 32,
    height: 32,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  featureCheck: {
    color: '#ffffff',
    fontWeight: '600',
  },
  featureText: {
    fontSize: 16,
    color: '#ffffff',
  },
});

export default BrandingPanel;
